import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { Route } from '@/modules/core/app/constants/api.constants';
import { TeamDeleteTeamChoice } from '@/modules/team/enums/TeamDeleteTeamChoice';
import { User } from '@/modules/user/models/User';
import { PredefinedProfession } from '@/modules/professional/enums/PredefinedProfession';
import { Team } from '@/modules/team/models/Team';
import { TeamRole } from '@/modules/team/constants/TeamRole';

class TeamResource extends BaseResource {
  async createTeam(team?: Team): Promise<Team> {
    return this.postData(Route.TEAMS_CREATE, team);
  }

  async setCurrentTeam(teamId?: number): Promise<void> {
    return this.postData(Route.TEAMS_SET_CURRENT_TEAM, {
      teamId
    });
  }

  async setCheckoutSessionTeamAsCurrentTeam(checkoutSessionId: string): Promise<Team> {
    return this.postData(Route.TEAMS_CHECKOUT_SET_CURRENT_TEAM, { checkoutSessionId });
  }

  async updateRole(team: Team, user: User, role: TeamRole): Promise<void> {
    return this.postData(Route.TEAMS_UPDATEROLE, {
      teamId: team.id,
      userId: user.id,
      role: role
    });
  }

  async inviteMembers(
    team: Team,
    emails: string[],
    profession: PredefinedProfession,
    isAdmin?: boolean
  ): Promise<void> {
    return this.postData(Route.TEAMS_INVITEMEMBERS, {
      teamId: team.id,
      emails,
      professionId: profession.id,
      isAdmin
    });
  }

  async deleteTeam(teamId: number, deleteChoice: TeamDeleteTeamChoice): Promise<void> {
    return this.postData(Route.TEAMS_DELETE, {
      teamId,
      deleteChoice: deleteChoice.key
    });
  }

  async deleteTeamMember(userId: number): Promise<void> {
    return this.postData(Route.TEAMS_DELETEMEMBER, {
      userId
    });
  }

  async getClearEstateCompanyEstateProfessionalTypeTeams(): Promise<Team[]> {
    return this.getData(Route.TEAMS_CLEAR_ESTATE_COMPANY_ESTATE_PROFESSIONAL_TYPE, Team);
  }
}

export default new TeamResource();
